import styled from 'styled-components';

export const HeaderLogo = styled.div`
  width: 100%;
  margin-top: 50px;
  display: flex;
  justify-content: center;
`;

export const WelcomeSearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: ${({ isSearch }) => (isSearch ? '40px' : '100px')};
  overflow-y: hidden;
`;

export const WelcomeSearchBody = styled.div`
  overflow: auto;
  min-height: 500px;
`;

export const WelcomeHeader = styled.div`
  margin-top: 25px;
  font-weight: 800;
  font-size: 28px;
  line-height: 34px;
`;

export const SearchHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 60px 0 20px;
  font-weight: 800;
  font-size: 28px;
  line-height: 34px;
  width: 375px;
  margin: 0 auto;
`;

export const SearchInputContainer = styled.div`
  width: 375px;
  margin: 30px auto 0;
  padding: 10px 20px;
  border-bottom: 1px solid #ecedf0;
  input {
    width: 315px;
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    &::placeholder {
      color: #7f7f82;
    }
  }
`;

export const WelcomeDescription = styled.div`
  margin-top: 10px;
  div {
    margin: 0 auto;
    width: 280px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
`;
export const ButtonBack = styled.button`
  background: #fafafa;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 0 9px;
  margin-right: 10px;
  svg {
    width: 17px;
    height: 17px;
  }
`;

export const WelcomeSearchButton = styled.button`
  padding: 15px 50px;
  background: #222224;
  border-radius: 26px;
  color: #fff;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  width: 335px;
  margin: 25px auto;
  span {
    max-width: none;
    margin-right: 10px;
    svg {
      width: 15px;
      height: 15px;
    }
  }
`;

export const ImageContainer = styled.span`
  margin-top: 90px;
`;

export const ChurchListContainer = styled.div`
  width: 335px;
  margin: 0 auto;
`;

export const ChurchListItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 20px;
  border-bottom: ${({ isNotLast }) => isNotLast && '1px solid #ECEDF0'};
`;

export const ChurchItemLogo = styled.div`
  box-shadow: 0px 9px 14px -7px rgba(0, 0, 0, 0.35);
  border-radius: 16px;
  width: 80px;
  height: 60px;
  background-position: center;
  background-size: 100% auto;
  background-image: url(${({ logo }) => logo});
  background-repeat: no-repeat;
  margin-right: 10px;
`;

export const ChurchItemNoLogo = styled.div`
  box-shadow: 0px 9px 14px -7px rgba(0, 0, 0, 0.35);
  border-radius: 16px;
  width: 80px;
  height: 60px;
  margin-right: 10px;
  background: #c4c4c4;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #7f7f82;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChurchItemName = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  span:first-child {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
  }
  span:last-child {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
  }
`;

export const ChurchSearchFooter = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f5f5f5;
  padding: 10px 0;
`;

export const FooterContent = styled.div`
  width: 290px;
  margin: 0 auto 5px;
  span {
    font-size: 16px;
    line-height: 24px;
  }
  span:first-child {
    font-weight: 400;
    margin-right: 10px;
  }
  span:last-child {
    font-weight: 600;
    cursor: pointer;
  }
`;

export const FooterDescription = styled.div`
  width: 160px;
  margin: 0 auto;
  span {
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: #4b4b4d;
  }
  span:first-child {
    padding-right: 8px;
    border-right: 1px solid #4b4b4d;
  }
  span:last-child {
    padding-left: 8px;
  }
`;
